import { useMemo } from 'react';
import { getBrowserTimezone } from '../../utils/get-browser-timezone';
import {
    getSeasonalThemeDecision,
    type SeasonalLoginSlideConfig,
    type SeasonalThemeContext,
} from './seasonalTheming';

export function getSeasonalLoginSlideDecision(
    context: Partial<SeasonalThemeContext> = {}
): SeasonalLoginSlideConfig | null {
    const finalContext = {
        date: new Date(),
        timezone: getBrowserTimezone(),
        ...context,
    };
    const theme = getSeasonalThemeDecision(finalContext);
    return theme?.loginSlide ?? null;
}

export function useSeasonalLoginSlide(): SeasonalLoginSlideConfig | null {
    return useMemo(() => getSeasonalLoginSlideDecision(), []);
}
